import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormDatePicker from "../../components/formFields/FormDateField";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { RootState } from "../../app/store";
import {
  getKarigarListByProcess,
  getKarigarStock,
} from "../karigar/services/karigar.services";
import { LoadingPanel } from "../../components/layout/Loading";
import { IKarigarListByProcess } from "../karigar/karigarModel";
import { findAllActiveItem } from "../item/services/item.services";
import {
  createPalishReceipt,
  findAllPendingPalishOrder,
  getPalishReceiptById,
  updatePalishReceipt,
} from "./services/palishReceipt.services";
import { findAllActiveProcess } from "../process/services/process.services";
import { clearPalishReceiptDetail } from "./palishReceiptSlice";
import { ErrorToast } from "../../components/toast/Toasts";
import { clearOrderDetail } from "../order/orderSlice";
import PalishReceiptOrderItemArray from "./PalishReceiptOrderItemArray";
import FormTextField from "../../components/formFields/FormTextField";
import PalishReceiptOrderSelectionDialog from "./PalishReceiptOrderSelectionDialog";
import { PRINT_ACCESS, PROCESS_ID } from "../../_contstants/common";
import { clearKarigarStock } from "../karigar/karigarSlice";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { FaEye } from "react-icons/fa";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const KarigarChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const karigar_id = formRenderProps.valueGetter("karigar_id");
  const KarigarList = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const charges = formRenderProps.valueGetter("charges");
  const gold_rate = formRenderProps.valueGetter("gold_rate");
  const palish_receipt_order = formRenderProps.valueGetter(
    "palish_receipt_order",
  );
  const dispatch = useAppDispatch();

  const fetchKarigarStock = async (karigar_id: number) => {
    await dispatch(getKarigarStock(karigar_id));
  };

  useEffect(() => {
    if (karigar_id) {
      dispatch(findAllPendingPalishOrder({ karigar_id: karigar_id }));
      fetchKarigarStock(karigar_id);
      if (karigar_id && KarigarList?.length > 0) {
        const selectedKarigar = KarigarList.find(
          (karigar) => karigar.karigar_id === karigar_id,
        );
        if (selectedKarigar) {
          const Rate = selectedKarigar?.rate;
          formRenderProps.onChange(`charges`, {
            value: Rate || 0,
          });
        }
      }
    }
  }, [karigar_id]);

  useEffect(() => {
    if (palish_receipt_order && palish_receipt_order.length > 0) {
      palish_receipt_order?.forEach((element: any, index: number) => {
        const total_charge = (element.issue_weight || 0) * (charges || 0);
        const ghat_weight =
          (element.issue_weight || 0) - (element.received_weight || 0);
        const amount = (ghat_weight || 0) * (gold_rate || 0);
        formRenderProps.onChange(`palish_receipt_order.${index}.total_charge`, {
          value: total_charge,
        });
        formRenderProps.onChange(`palish_receipt_order.${index}.ghat_weight`, {
          value: ghat_weight,
        });
        formRenderProps.onChange(`palish_receipt_order.${index}.amount`, {
          value: amount,
        });
      });
    }
  }, [
    palish_receipt_order?.map((item: any) => item?.issue_weight).join("-"),
    palish_receipt_order?.map((item: any) => item?.received_weight).join("-"),
    charges,
    gold_rate,
  ]);
  return null;
};
const CreatePalishReceipt: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const palish_receipt_guid = location?.state?.palish_receipt_guid;
  const loading = useAppSelector((state) => state.palishreceipt?.loading);
  const karigarStock = useAppSelector((state) => state.karigar.KarigarStock);
  const isPrintAccess = checkAcessRights(
    "/" + location.pathname.split("/")[1],
    PRINT_ACCESS,
  );
  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const PalishReceiptDetail = useAppSelector(
    (state: RootState) => state.palishreceipt.PalishReceiptDetail,
  );
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    dispatch(getKarigarListByProcess(PROCESS_ID.palish));
    dispatch(findAllActiveItem());
    dispatch(findAllActiveProcess());
    return () => {
      dispatch(clearPalishReceiptDetail());
      dispatch(clearOrderDetail());
      dispatch(clearKarigarStock());
    };
  }, []);

  useEffect(() => {
    if (palish_receipt_guid) {
      dispatch(getPalishReceiptById(palish_receipt_guid));
    }
  }, [palish_receipt_guid]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [PalishReceiptDetail]);

  const handleSubmit = async (values: any) => {
    if (values.palish_receipt_order?.length === 0) {
      ErrorToast("At least One Order is Required !");
      return false;
    }
    const formData = {
      karigar_id: values.karigar_id ? +values.karigar_id : null,
      receipt_date: values.receipt_date
        ? moment(values.receipt_date).format("YYYY-MM-DD")
        : "",
      charges: values?.charges ? values?.charges : 0,
      gold_rate: values?.gold_rate ? values?.gold_rate : 0,

      palish_receipt_order: values.palish_receipt_order
        ? values.palish_receipt_order.map((palishreceiptOrder: any) => {
            return {
              id: palishreceiptOrder.id ? palishreceiptOrder.id : 0,
              order_id: palishreceiptOrder.order_id
                ? +palishreceiptOrder.order_id
                : null,
              item_id: palishreceiptOrder.item_id
                ? +palishreceiptOrder.item_id
                : null,
              item_description: palishreceiptOrder.item_description
                ? palishreceiptOrder.item_description
                : "",
              issue_weight: palishreceiptOrder.issue_weight
                ? palishreceiptOrder.issue_weight
                : 0,
              received_weight: palishreceiptOrder.received_weight
                ? palishreceiptOrder.received_weight
                : 0,
              total_charge: palishreceiptOrder.total_charge
                ? palishreceiptOrder.total_charge
                : 0,
              ghat_weight: palishreceiptOrder.ghat_weight
                ? palishreceiptOrder.ghat_weight
                : 0,
              amount: palishreceiptOrder.amount ? palishreceiptOrder.amount : 0,
              isfinishorder: palishreceiptOrder.isfinishorder
                ? palishreceiptOrder.isfinishorder
                : false,
              IsVerified: palishreceiptOrder.IsVerified
                ? palishreceiptOrder.IsVerified
                : false,
            };
          })
        : [],
    };
    if (palish_receipt_guid) {
      const editPayload = {
        palish_receipt_guid: palish_receipt_guid,
        palish_receipt_no: values.palish_receipt_no,
        ...formData,
      };
      try {
        const response = await dispatch(updatePalishReceipt(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/palishreceipt");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createPalishReceipt(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/palishreceipt");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };
  const handleFormClose = () => {
    navigate("/palishreceipt");
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={PalishReceiptDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <PalishReceiptOrderSelectionDialog
              formRenderProps={formRenderProps}
            />
            <KarigarChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {palish_receipt_guid
                      ? "Update Palish Receipt"
                      : "Create Palish Receipt"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  {palish_receipt_guid ? (
                    <Typography.h5>
                      Palish Receipt No :{" "}
                      <span style={{ color: "green" }}>
                        {PalishReceiptDetail.palish_receipt_no}
                      </span>
                    </Typography.h5>
                  ) : (
                    ""
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="karigar_id"
                    label="Karigar Name"
                    placeholder="Select Karigar"
                    isAddNew={true}
                    addNewLink="karigar/create"
                    dispatcherFunction={getKarigarListByProcess}
                    dispatcherFunctionPayload={PROCESS_ID.palish}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={KarigarListByProcess?.map(
                      (karigar: IKarigarListByProcess) => {
                        return {
                          value: karigar?.karigar_id,
                          label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="receipt_date"
                    label="Receipt Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <div className="stock-container">
                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot amount-dot-${karigarStock.Amount_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Amount Balance
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value amount-value-${karigarStock.Amount_credit_debit}`}
                      >
                        {formatToIndianCurrencyWithoutSymbol(
                          karigarStock.amount || 0,
                        )}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.Amount_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>

                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot phine-dot-${karigarStock.phine_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Phine (gm) Stock
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value phine-value-${karigarStock.phine_credit_debit}`}
                      >
                        {formatWeight(karigarStock.phine)}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.phine_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>
                  </div>
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={2}
                  style={{ display: "flex", gap: 10 }}
                >
                  <Field
                    name="charges"
                    label="Charges"
                    placeholder="i.e. 2"
                    wrapperStyle={{ width: "100%" }}
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                  <Field
                    name="gold_rate"
                    label="Gold Rate (GM)"
                    wrapperStyle={{ width: "100%" }}
                    placeholder="i.e. 8500"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayout cols={[{ width: "100%" }]}>
                <GridLayoutItem>
                  <Typography.h4>Palish Receipt Orders</Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={PalishReceiptOrderItemArray}
                    name="palish_receipt_order"
                    palish_receipt_guid={palish_receipt_guid}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  {isPrintAccess && palish_receipt_guid && (
                    <Button
                      type="button"
                      style={{ marginRight: 4 }}
                      fillMode={"solid"}
                      themeColor={"primary"}
                      onClick={() =>
                        window.open(
                          `/palishreceipt/${palish_receipt_guid}`,
                          "_blank",
                        )
                      }
                    >
                      <FaEye style={{ fontSize: "18" }} /> View Report
                    </Button>
                  )}
                  <ButtonWithLoading
                    label={!palish_receipt_guid ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreatePalishReceipt;
